import { render } from "./HeroTablePage.vue?vue&type=template&id=0fd99043&scoped=true"
import script from "./HeroTablePage.vue?vue&type=script&lang=js"
export * from "./HeroTablePage.vue?vue&type=script&lang=js"

import "./HeroTablePage.vue?vue&type=style&index=0&id=0fd99043&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd99043"]])

export default __exports__